import { Box, CircularProgress } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import { COMPLIANCE_COVERAGE_STATUS_VIEW } from './constants';
import { ComplianceCoverageStatus } from './types';

type ComplianceAudienceCoverageStatusCellProps = {
  status: ComplianceCoverageStatus;
};

const renderBadgeStatus = (statusView: (typeof COMPLIANCE_COVERAGE_STATUS_VIEW)[ComplianceCoverageStatus]) => (
  <Box display="flex" alignItems="center" gap={0.5} mr={1}>
    <Badge color={statusView.color}>{statusView.label}</Badge>
  </Box>
);

const STATUS_RENDERERS: Record<
  ComplianceCoverageStatus,
  (props: ComplianceAudienceCoverageStatusCellProps) => React.ReactNode
> = {
  [ComplianceCoverageStatus.LOADING]: () => <CircularProgress size={16} sx={{ color: 'text.secondary', mr: 1 }} />,
  [ComplianceCoverageStatus.SIGNED]: () => renderBadgeStatus(COMPLIANCE_COVERAGE_STATUS_VIEW.SIGNED),
  [ComplianceCoverageStatus.NOT_SIGNED]: () => renderBadgeStatus(COMPLIANCE_COVERAGE_STATUS_VIEW.NOT_SIGNED),
  [ComplianceCoverageStatus.UNAVAILABLE]: () => renderBadgeStatus(COMPLIANCE_COVERAGE_STATUS_VIEW.UNAVAILABLE),
};

const ComplianceAudienceCoverageStatusCell = (props: ComplianceAudienceCoverageStatusCellProps) => {
  const renderStatus = STATUS_RENDERERS[props.status];

  return renderStatus(props);
};

export default ComplianceAudienceCoverageStatusCell;
